"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactFlowControls = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
require("../styles/react-flow-controls.scss");
/**
 * Custom controls for ReactFlow
 */
exports.ReactFlowControls = function (_a) {
    var onFitView = _a.onFitView, onToggleFullscreen = _a.onToggleFullscreen, onScreenshot = _a.onScreenshot, isFullscreen = _a.isFullscreen;
    return (react_1.default.createElement("div", { className: "react-flow-custom-controls" },
        react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'FitPage' }, title: "Reset View", ariaLabel: "Reset View", className: "ws-admin-button-hover-accent", onClick: onFitView }),
        react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'Camera' }, title: "Take Screenshot", ariaLabel: "Take Screenshot", className: "ws-admin-button-hover-accent", onClick: onScreenshot }),
        react_1.default.createElement(Button_1.IconButton, { iconProps: {
                iconName: isFullscreen ? 'BackToWindow' : 'FullScreen',
            }, title: isFullscreen ? 'Exit Fullscreen' : 'Fullscreen', ariaLabel: isFullscreen ? 'Exit Fullscreen' : 'Fullscreen', className: "ws-admin-button-hover-accent", onClick: onToggleFullscreen })));
};
